import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {REQUEST_STATUS_NAMES, REQUEST_STATUSES, RequestStatus} from 'requests/RequestConstants';
import {RequestStatusIcon} from 'requests/RequestStatusIcon';

interface RequestStatusLabelProps {
  requestStatus: RequestStatus;
}
export default function RequestStatusLabel(props: RequestStatusLabelProps): JSX.Element {
  return (
    <span
      className={classNames('requestSampleStatusCounts-iconCount', {
        'requestStatusLabel--completed': props.requestStatus === RequestStatus.COMPLETED,
        'requestStatusLabel--inProgress': props.requestStatus === RequestStatus.IN_PROGRESS,
      })}
    >
      <RequestStatusIcon status={props.requestStatus} className={css(styles.statusIcon)} />
      {REQUEST_STATUS_NAMES[props.requestStatus]}
    </span>
  );
}
RequestStatusLabel.propTypes = {
  requestStatus: PropTypes.oneOf(REQUEST_STATUSES),
};

const styles = StyleSheet.create({
  statusIcon: {
    marginRight: '10px',
  },
});
